import { useSyncExternalStore } from "react";
import { readWorkflowPreferences, workflowPreferenceKey } from "../lib/workflowPreferences";

const eventName = "bimgo-workflow-preferences";
function subscribe(notify: () => void) {
  window.addEventListener("storage", notify);
  window.addEventListener(eventName, notify);
  return () => {
    window.removeEventListener("storage", notify);
    window.removeEventListener(eventName, notify);
  };
}

export function useWorkflowPreferences(userId: string | null) {
  const key = userId ? workflowPreferenceKey(userId) : null;
  const raw = useSyncExternalStore(subscribe, () => {
    try { return key ? localStorage.getItem(key) : null; }
    catch { return null; }
  }, () => null);
  return {
    enabledIds: readWorkflowPreferences(raw),
    setEnabled(id: string, enabled: boolean) {
      if (!key) return;
      const ids = readWorkflowPreferences(localStorage.getItem(key)).filter((value) => value !== id);
      if (enabled) ids.push(id);
      localStorage.setItem(key, JSON.stringify(ids));
      window.dispatchEvent(new Event(eventName));
    },
  };
}
